// export const BASE_URL = 'http://acrobaciasserranas.com.ar';
// export const BASE_URL = 'http://localhost:4000';
// 'http://acrobaciasserranas.com.ar';
export const lightDefaultColor = '#d2e0ef';
export const INICIO_CONTROL_PAGOS = '2023-04-01'; // YYYY-MM-DD